import { createTheme, globalTheme } from '@clds/component-theme';

const palette = globalTheme.palette;
const spacing = globalTheme.spacing;

export const theme = createTheme({
  background: {
    color: palette.surface,
  },
  border: {
    color: {
      normal: palette.secondaryAlt,
      focus: palette.primary,
    },
    radius: globalTheme.radius.lg,
  },
  helperText: {
    color: palette.contrastHigh,
  },
  text: {
    padding: {
      vertical: spacing.sm,
      horizontal: spacing.xs,
    },
  },
});
